module.exports = __webpack_public_path__ + "img/elogo.b87cbfda.png";